export const timezoneList = [
  { id: 2, name: 'UTC+2 — Калининград' },
  { id: 3, name: 'UTC+3 — Москва' },
  { id: 4, name: 'UTC+4 — Самара, Ижевск' },
  { id: 5, name: 'UTC+5 — Екатеринбург' },
  { id: 6, name: 'UTC+6 — Омск' },
  { id: 7, name: 'UTC+7 — Красноярск, Новосибирск' },
  { id: 8, name: 'UTC+8 — Иркутск' },
  { id: 9, name: 'UTC+9 — Якутск' },
  { id: 10, name: 'UTC+10 — Владивосток' },
  { id: 11, name: 'UTC+11 — Магадан, Сахалин' },
  { id: 12, name: 'UTC+12 — Камчатка, Чукотка' },
];
